import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=324a5173"
import script from "./notices.vue?vue&type=script&lang=js"
export * from "./notices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports